module.exports = __webpack_public_path__ + "static/media/N3.7666c29a.png";